define("diy/undo-redo/constants",
    [],
    /**
     * Constants used by api
     *
     * @class module.undoRedo.constants
     * @template module.undoRedo.constants
     * @lends {module.undoRedo.constants.prototype}
     * @constructor
     */
    {
        /**
         * entry types 'undo' and 'redo'
         */
        types: {
            UNDO: 'undo',
            REDO: 'redo'
        },
        /**
         * entry execution types - if an entry is executed client side or server side
         */
        executionType: {
            CLIENT: 'client',
            SERVER: 'server'
        },
        /**
         * timeout for entry execution. if execution exceeds number of milliseconds,
         *      the corresponding promise will fail with timeout
         */
        executionTimeout: 60000,
        applyResultsTimeout: 10000,
        executionTimeoutMessage: 'TIMEOUT',

        /**
         * Features are written here for convenience
         * @see {module.undoRedo.Settings.features} for feature definition
         */
        features: {
            STYLE: 'style',
            PAGES: 'pages',
            LAYOUTS: 'layouts',
            DESIGNS: 'designs',
        },
        observerTopics: {
            ALL: '*',
            HISTORY_CHAIN_UPDATED: 'historyChainUpdated',
            HISTORY_CHAIN_READY: 'historyChainReady',
            EXECUTION_FINISHED: 'executionFinished'
        },

        historyEntry: {
            MODULE: 'module',
            MODULE_SECTION: 'module_Section',
            LAYOUT: 'layout',
            DESIGN: 'design',
            PAGES_STRUCTURE: 'pagesStructure',
            STYLE: 'style',
            THEMING: 'theming'
        },
        status: {
            SYNC: -3,
            LOCK: -2,
            INIT: -1,
            READY: 0,
            LOADING: 1,
            EXECUTING: 2,
            ERROR: 3,
            TIMEOUT: 4
        }

    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/constants.js
 ** module id = 889
 ** module chunks = 0
 **/